// extracted by mini-css-extract-plugin
export var icon = "_bs-3";
export var subtitle = "_bs-2";
export var title = "_bs-1";
export var value = "_bs-0";